import React, { useEffect, useState } from "react";
import { API, UPLOADS } from "./../../config/api";
import { useLocation } from "react-router-dom";
export default function Pendingdesigner({ type = "designer" }) {
  const location = useLocation();
  const [designers, setDesigners] = useState([]);
  const [selectedDesigner, setSelectedDesigner] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 25;

  const [statusFilter, setStatusFilter] = useState(
    location.state?.status || "all",
  );
  useEffect(() => {
    if (location.state?.status) {
      setStatusFilter(location.state.status);
    }
  }, [location.state]);
  // New Search & Filter States
  const [searchTerm, setSearchTerm] = useState("");

  // Fetch Pending Designers
  useEffect(() => {
    fetchDesigners();
  }, []);

  const fetchDesigners = async () => {
    const res = await fetch(`${API.LIST_PENDING}&profile_type=${type}`);

    const data = await res.json();
    setDesigners(data);
  };
  const handleView = (designer) => {
    setSelectedDesigner(designer);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
  };

  // Accept Designer
  const handleAccept = async () => {
    try {
      const formData = new FormData();
      formData.append("id", selectedDesigner.id);
      formData.append("status", "active");

      await fetch(API.UPDATE_DESIGNER_STATUS, {
        method: "POST",
        body: formData,
      });

      fetchDesigners();
      setShowModal(false);
    } catch (error) {
      console.error("Accept Error:", error);
    }
  };

  // Reject (Delete) Designer
  const handleReject = async () => {
    const confirmDelete = window.confirm(
      "Are you sure? Rejecting this designer will permanently delete them from the database.",
    );

    if (!confirmDelete) return;

    try {
      const formData = new FormData();
      formData.append("id", selectedDesigner.id);

      const res = await fetch(API.DELETE_DESIGNER, {
        method: "POST",
        body: formData,
      });

      const data = await res.json();
      alert(data.message);

      fetchDesigners();
      setShowModal(false);
    } catch (error) {
      console.error("Delete Error:", error);
    }
  };

  // Filter Logic
  const filteredDesigners = designers.filter((item) => {
    // 1. Filter by Status
    const matchesStatus =
      statusFilter === "all" ||
      (item.status && item.status.toLowerCase() === statusFilter.toLowerCase());

    // 2. Filter by Search Term (Name, Phone, Email, User ID)
    const term = searchTerm.toLowerCase().trim();
    const matchesSearch =
      !term ||
      (item.name && item.name.toLowerCase().includes(term)) ||
      (item.phone && item.phone.toString().includes(term)) ||
      (item.email && item.email.toLowerCase().includes(term)) ||
      (item.user_id && item.user_id.toString().includes(term));

    return matchesStatus && matchesSearch;
  });
  const totalPages = Math.ceil(filteredDesigners.length / itemsPerPage);

  const paginatedDesigners = filteredDesigners.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  return (
    <div className="pds-dashboard-container">
      <h2 className="pds-main-title">
        {type === "designer" ? "Designer Requests" : "Sketcher Requests"}
      </h2>

      {/* Search and Filter Controls */}
      <div className="pds-filter-panel">
        <div className="pds-control-group">
          <label className="pds-control-label">Search Designer</label>
          <input
            type="text"
            className="pds-input-field"
            placeholder="Search by name, email, mobile, ID..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
        <div className="pds-control-group">
          <label className="pds-control-label">Filter Status</label>
          <select
            className="pds-select-field"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">All Statuses</option>
            <option value="pending">Pending</option>
            <option value="active">Active</option>
          </select>
        </div>
      </div>

      <div className="pds-table-responsive">
        <table className="pds-custom-table">
          <thead>
            <tr>
              <th>#</th>
              <th>User Id</th>
              <th>Date</th>
              <th>Image</th>
              <th>Name</th>

              <th>Experience</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {filteredDesigners.length > 0 ? (
              paginatedDesigners.map((item, index) => (
                <tr key={item.id}>
                  <td>
                    {filteredDesigners.length -
                      ((currentPage - 1) * itemsPerPage + index)}
                  </td>

                  <td>{item.user_id}</td>
                  <td>
                    <div className="pds-date-text">
                      {new Date(item.created_at).toLocaleDateString()}
                    </div>
                    <div className="pds-time-text">
                      {new Date(item.created_at).toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </div>
                  </td>
                  <td>
                    <img
                      // src={`${
                      //   type === "designer"
                      //     ? UPLOADS.DESIGNER_IMAGE
                      //     : UPLOADS.SKETCHER_IMAGE
                      // }${item.profile}`}
                      src={`${UPLOADS.DESIGNER_IMAGE}${item.profile}`}
                      alt={item.name}
                      className="ad-table-img"
                    />
                  </td>
                  <td>
                    <div className="fw-bold">{item.name}</div>
                    <div className="text-muted small">{item.phone}</div>
                    <div className="text-muted small">{item.email}</div>
                  </td>

                  {/* <td>{item.email}</td> */}

                  <td>{item.experience}</td>
                  <td>
                    <span
                      className={`pds-status-badge pds-badge-${
                        item.status === "active" ? "active" : "pending"
                      }`}
                    >
                      {item.status}
                    </span>
                  </td>

                  <td>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <button
                        className="pds-action-btn-view"
                        onClick={() => handleView(item)}
                      >
                        <i className="bi bi-eye"></i>
                      </button>
                    </div>
                  </td>
                  {/* 
                  <td>
                    <button
                      className="pds-action-btn-view"
                      onClick={() => handleView(item)}
                    >
                      View Details
                    </button>
                  </td> */}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="pds-table-empty-state">
                  No designers match your search criteria.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {totalPages > 1 && (
        <div className="d-flex justify-content-center gap-2 mt-3">
          <button
            className="btn btn-sm btn-secondary"
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            Prev
          </button>

          {[...Array(totalPages)].map((_, i) => {
            const page = i + 1;

            if (
              page === 1 ||
              page === totalPages ||
              Math.abs(page - currentPage) <= 1
            ) {
              return (
                <button
                  key={page}
                  className={`btn btn-sm ${
                    currentPage === page ? "btn-primary" : "btn-outline-primary"
                  }`}
                  onClick={() => setCurrentPage(page)}
                >
                  {page}
                </button>
              );
            }

            if (page === currentPage - 2 || page === currentPage + 2) {
              return <span key={page}>...</span>;
            }

            return null;
          })}

          <button
            className="btn btn-sm btn-secondary"
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            Next
          </button>
        </div>
      )}

      {/* Modal */}
      {showModal && selectedDesigner && (
        <div className="pds-modal-backdrop">
          <div className="pds-modal-wrapper">
            <div className="pds-modal-header">
              <h3>
                {type === "designer" ? "Designer Profile" : "Sketcher Profile"}
              </h3>
              <button className="pds-modal-close-x" onClick={handleClose}>
                &times;
              </button>
            </div>

            <div className="pds-modal-body">
              {/* Left Side: Profile Card */}
              <div className="pds-modal-left-column">
                <div className="pds-avatar-wrapper">
                  <img
                    src={`${UPLOADS.DESIGNER_IMAGE}${selectedDesigner.profile}`}
                    alt={selectedDesigner.name}
                    className="pds-avatar-img"
                  />
                </div>
                <div className="pds-badge-container">
                  <span
                    className={`pds-status-badge pds-badge-${
                      selectedDesigner.status === "active"
                        ? "active"
                        : "pending"
                    }`}
                  >
                    {selectedDesigner.status}
                  </span>
                </div>
              </div>

              {/* Right Side: Details Grid */}
              <div className="pds-modal-right-column">
                <div className="pds-grid-system">
                  <div className="pds-grid-item">
                    <span className="pds-detail-label">Full Name</span>
                    <span className="pds-detail-val">
                      {selectedDesigner.name}
                    </span>
                  </div>
                  <div className="pds-grid-item">
                    <span className="pds-detail-label">Experience</span>
                    <span className="pds-detail-val">
                      {selectedDesigner.experience}
                    </span>
                  </div>

                  <div className="pds-grid-item">
                    <span className="pds-detail-label">Mobile No</span>
                    <span className="pds-detail-val">
                      {selectedDesigner.phone}
                    </span>
                  </div>
                  <div className="pds-grid-item">
                    <span className="pds-detail-label">Expected Salary</span>
                    <span className="pds-detail-val pds-salary-text">
                      ₹{selectedDesigner.expected_salary}
                    </span>
                  </div>

                  <div className="pds-grid-item pds-col-fullwidth">
                    <span className="pds-detail-label">Email Address</span>
                    <span className="pds-detail-val">
                      {selectedDesigner.email}
                    </span>
                  </div>

                  <div className="pds-grid-item">
                    <span className="pds-detail-label">Skills</span>
                    <span className="pds-detail-val">
                      {selectedDesigner.skills || ""}
                    </span>
                  </div>
                  <div className="pds-grid-item">
                    <span className="pds-detail-label">Location</span>
                    <span className="pds-detail-val">
                      {selectedDesigner.location || ""}
                    </span>
                  </div>

                  <div className="pds-grid-item pds-col-fullwidth">
                    <span className="pds-detail-label">Description</span>
                    <p className="pds-detail-paragraph">
                      {selectedDesigner.description}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="pds-modal-footer">
              <button
                className="pds-btn pds-btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>
              <button className="pds-btn pds-btn-danger" onClick={handleReject}>
                Reject & Delete
              </button>
              {selectedDesigner.status !== "active" && (
                <button
                  className="pds-btn pds-btn-success"
                  onClick={handleAccept}
                >
                  {type === "designer" ? "Accept Designer" : "Accept Sketcher"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
